<div class="header-bar">
  <h1 *ngIf="orgTypeId == 1">Organisations</h1>
  <h1 *ngIf="orgTypeId == 3">Customers</h1>
</div>
<div class="content-container">
  <form (ngSubmit)="search()" style="width: 100%">
    <div class="ui-g filterPanel">
      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <span class="md-inputfield filterItem">
          <input name="name" type="text" pInputText [(ngModel)]="filterVal.filters.name.value" />
          <label>Name</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <span class="md-inputfield filterItem">
          <input
            name="addressLine1"
            type="text"
            pInputText
            [(ngModel)]="filterVal.filters.addressLine1.value"
          />
          <label>Address</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <span class="md-inputfield filterItem">
          <input name="town" type="text" pInputText [(ngModel)]="filterVal.filters.town.value" />
          <label>Town</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <span class="md-inputfield filterItem">
          <input
            name="postcode"
            type="text"
            pInputText
            [(ngModel)]="filterVal.filters.postcode.value"
          />
          <label>Postcode</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2" *ngIf="orgTypeId == 1">
        <p-dropdown
          name="organisationTypeName"
          [options]="organisationtypes"
          [(ngModel)]="filterVal.filters.organisationTypeName.value"
          styleClass="filterItem"
          [style]="{ width: '100%' }"
        ></p-dropdown>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2" *ngIf="orgTypeId == 1">
        <p-dropdown
          name="orgStatusOptions"
          [options]="organisationStatusOptions"
          [(ngModel)]="filterVal.filters.orgStatus.value"
          styleClass="filterItem"
        ></p-dropdown>
      </div>

      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <button pButton type="submit" label="Search"></button>
        <button pButton type="button" label="Clear" (click)="clearFilter(dt)"></button>
      </div>
    </div>
  </form>

  <p-table
    #dt
    selectionMode="single"
    [(selection)]="selectedItem"
    [value]="page.items"
    [lazy]="true"
    [rows]="filterVal.rows"
    [responsive]="true"
    [first]="filterVal.first"
    [paginator]="true"
    rowHover="true"
    resizableColumns="true"
    [rowsPerPageOptions]="[5, 10, 20]"
    [pageLinks]="3"
    [totalRecords]="page.total"
    [styleClass]="'rowStyle'"
    (onLazyLoad)="onGridLazyLoad($event)"
    [sortField]="filterVal.sortField"
    [sortOrder]="filterVal.sortOrder"
    [hidden]="!isLoaded"
    [loading]="isLoading"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">Name</th>
        <th pSortableColumn="addressLine1">Address</th>
        <th pSortableColumn="town">Town</th>
        <th pSortableColumn="postcode">Postcode</th>
        <th *ngIf="orgTypeId == 1" pSortableColumn="organisationTypeName">Organisation Type</th>
        <th *ngIf="orgTypeId == 1">Invoice Address</th>
        <th>Audit</th>
        <th>Active</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr (dblclick)="goToDetails(item.id, item.organisationTypeId, user)" [pSelectableRow]="item">
        <td>{{ item.name }}</td>
        <td>{{ item.addressLine1 }}</td>
        <td>{{ item.town }}</td>
        <td>{{ item.postcode }}</td>
        <td *ngIf="orgTypeId == 1">{{ item.organisationTypeName }}</td>
        <td *ngIf="orgTypeId == 1" class="text-center">
          <span
            ><a
              *ngIf="item.organisationTypeId == 2"
              href="/app/invoiceaddresses;orgid={{ item.id }}"
              target="_blank"
              icon="pi pi-search"
              >View</a
            ></span
          >
        </td>
        <td style="text-align: center">
          <button
            *ngIf="item.organisationTypeId == 3"
            pButton
            class="secondary-outline"
            (click)="showAudit(item)"
            icon="fa fa-list"
            label="View"
          ></button>
        </td>
        <td
          style="text-align: center"
          tooltipStyleClass="xtooltip"
          [pTooltip]="
            item.suspended ? 'Organisation suspended by ' + item.suspendedByUserName : null
          "
        >
          <i
            class="fa fa-check check-green"
            *ngIf="item.inactive == null && item.suspended == null"
          ></i>
          <i class="fa fa-times times-red" *ngIf="item.inactive != null"></i>
          <i class="fa fa-warning" style="color: #f97316" *ngIf="item.suspended != null"></i>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- TABLE DEPRECATED --
  <p-dataTabl #dt selectionMode="single" [(selection)]="selectedItem" [value]="page.items" [lazy]="true" [rows]="filterVal.rows" [responsive]="true" [first]="filterVal.first"
           [paginator]="true" rowHover="true" resizableColumns="true" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3" [totalRecords]="page.total"
           [styleClass]="'rowStyle'"
           (onLazyLoad)="onGridLazyLoad($event)" [sortField]="filterVal.sortField" [sortOrder]="filterVal.sortOrder"
           (onRowDblclick)="goToDetails(selectedItem.id, selectedItem.organisationTypeId,user)"
           [hidden]="!isLoaded">

  <p-column field="name" header="Name" [sortable]="tru" [editable]="false"></p-column>
  <p-column field="addressLine1" header="Address" [sortable]="tru" [editable]="false"></p-column>
  <p-column field="town" header="Town" [sortable]="tru" [editable]="false"></p-column>
  <p-column field="postcode" header="Postcode" [sortable]="tru" [editable]="false"></p-column>
  <p-column field="organisationTypeName" header="Organisation Type" *ngIf="orgTypeId == 1"></p-column>
  <p-column field="" header="Invoice Address" *ngIf="orgTypeId == 1" styleClass="align-center">
      <ng-template let-row="rowData" pTemplate type="body">
          <span><a *ngIf="row.organisationTypeId == 2" href="/app/invoiceaddresses;orgid={{row.id}}" target="_blank" icon="pi pi-search">View</a></span>
      </ng-template>
  </p-column>
  <p-column field="dateCreated" header="Created" [sortable]="tru">

      <ng-template let-row="rowData" pTemplate="body">
          {{row.dateCreated | date:'dd/MM/yyyy'}}
      </ng-template>

  </p-column>
  </p-dataTable>
  -->

  <div class="footerPanel ui-grid-row" *ngIf="isLoaded">
    <button
      class="btn-to-right"
      type="button"
      (click)="goToUsers(selectedItem.id)"
      label="Users"
      pButton
      icon="fa ui-icon-people"
      *ngIf="isAvailableEditing"
      [disabled]="!selectedItem"
    ></button>
    <button
      class="btn-to-right"
      type="button"
      (click)="showCustomerDetail(selectedItem)"
      label="View"
      pButton
      icon="fa ui-icon-mode-edit"
      *ngIf="!isAvailableEditing"
      [disabled]="!selectedItem"
    ></button>

    <button
      class="btn-to-right"
      type="button"
      (click)="goToDetails(selectedItem.id, selectedItem.organisationTypeId, user)"
      label="Edit"
      pButton
      icon="fa ui-icon-mode-edit"
      *ngIf="isAvailableEditing"
      [disabled]="!selectedItem"
    ></button>
    <button
      class="btn-to-right"
      type="button"
      pButton
      icon="fa ui-icon-add"
      (click)="AddOrganisation(user)"
      label="Add"
      *ngIf="isAvailableEditing"
    ></button>

    <button
      class="btn-to-right"
      type="button"
      pButton
      icon="pi pi-tags"
      (click)="CustomerTags(selectedItem)"
      label="Tags"
      *ngIf="isAvailableEditing && selectedItem && selectedItem.organisationTypeId == 2"
      [disabled]="!selectedItem"
    ></button>
  </div>

  <p-dialog
    header="Customer"
    [(visible)]="showViewDialog"
    [responsive]="true"
    [modal]="true"
    [style]="{ width: '500px' }"
  >
    <div class="ui-grid ui-grid-responsive ui-fluid" *ngIf="selectedItem">
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="name">Name</label></div>
        <div class="ui-g-8">
          <input
            pInputText
            id="name"
            name="name"
            maxlength="50"
            [(ngModel)]="selectedItem.name"
            [disabled]="true"
          />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="addressLine1">Address line 1</label></div>
        <div class="ui-g-8">
          <input
            pInputText
            id="addressLine1"
            name="addressLine1"
            maxlength="50"
            [(ngModel)]="selectedItem.addressLine1"
            [disabled]="true"
          />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="addressLine2">Address line 2</label></div>
        <div class="ui-g-8">
          <input
            pInputText
            id="addressLine2"
            name="addressLine2"
            maxlength="50"
            [(ngModel)]="selectedItem.addressLine2"
            [disabled]="true"
          />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="addressLine3">Address line 3</label></div>
        <div class="ui-g-8">
          <input
            pInputText
            id="addressLine3"
            name="addressLine3"
            maxlength="50"
            [(ngModel)]="selectedItem.addressLine3"
            [disabled]="true"
          />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="town">Town</label></div>
        <div class="ui-g-8">
          <input
            pInputText
            id="town"
            name="town"
            maxlength="50"
            [(ngModel)]="selectedItem.town"
            [disabled]="true"
          />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="postcode">Post Code</label></div>
        <div class="ui-g-8">
          <input
            pInputText
            id="postcode"
            name="postcode"
            maxlength="50"
            [(ngModel)]="selectedItem.postcode"
            [disabled]="true"
          />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="emailAddress">Email address</label></div>
        <div class="ui-g-8">
          <input
            pInputText
            id="emailAddress"
            name="emailAddress"
            maxlength="50"
            [(ngModel)]="selectedItem.emailAddress"
            [disabled]="true"
          />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="phoneNumber">Phone</label></div>
        <div class="ui-g-8">
          <input
            pInputText
            type="tel"
            id="phoneNumber"
            name="phoneNumber"
            maxlength="50"
            [(ngModel)]="selectedItem.phoneNumber"
            [disabled]="true"
          />
        </div>
      </div>
    </div>

    <div style="float: right">
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Close"
        (click)="closeViewDialog()"
      ></button>
    </div>
  </p-dialog>

  <customer-tagging #customerTagging></customer-tagging>
</div>
<ng-template #loading>Loading...</ng-template>

<p-dialog
  header="Capability Audit"
  [(visible)]="showAuditDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '800px' }"
>
  <div
    *ngIf="capabilityAudits?.length == 0"
    style="
      line-height: 2rem;
      border: 1px solid #ccc;
      border-radius: 8px;
      font-size: 1rem;
      text-align: center;
      margin-bottom: 15px;
      padding: 10px;
      text-align: center;
    "
  >
    No capability audit records for {{ auditOrg?.name }}
  </div>

  <div style="font-size: 1.25em; margin-bottom: 0.75em">Tagging Audit</div>

  <div
    *ngIf="taggingAudits?.length == 0"
    style="
      line-height: 2rem;
      border: 1px solid #ccc;
      border-radius: 8px;
      font-size: 1rem;
      text-align: center;
      margin-bottom: 15px;
      padding: 10px;
      text-align: center;
    "
  >
    No tagging audit records for {{ auditOrg?.name }}
  </div>

  <div
    *ngIf="taggingAudits?.length > 0"
    style="max-height: 132px; overflow-y: auto; margin-bottom: 15px"
  >
    <p-table
      selectionMode="none"
      [value]="taggingAudits"
      [lazy]="true"
      [responsive]="true"
      [paginator]="false"
      [styleClass]="'rowStyle'"
      [resizableColumns]="true"
      [autoLayout]="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="text-align: left">Date/Time</th>
          <th style="text-align: left">Entity</th>
          <th style="text-align: left">Description</th>
          <th style="text-align: left">User</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.updatedDate | datex : 'DD MMM HH:mm' }}</td>
          <td>{{ item.tagEntity.name }}</td>
          <td>{{ replaceAuditDescription(item) }}</td>
          <td>{{ item.updatedByUserName }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div style="font-size: 1.25em; margin-bottom: 0.75em">Customer Preferences</div>

  <div
    *ngIf="capabilityAudits?.length > 0"
    style="max-height: 132px; overflow-y: auto; margin-bottom: 15px"
  >
    <p-table
      selectionMode="none"
      [value]="capabilityAudits"
      [lazy]="true"
      [responsive]="true"
      [paginator]="false"
      [styleClass]="'rowStyle'"
      [resizableColumns]="true"
      [autoLayout]="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Date/Time</th>
          <th>Area</th>
          <th>Action</th>
          <th>User</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.timeStamp | datex : 'DD MMM HH:mm' }}</td>
          <td>{{ splitByCaps(CapabilityAuditArea[item.auditArea]) }}</td>
          <td>{{ item.auditText }}</td>
          <td>{{ item.userName }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div
    *ngIf="customerOrderPreferences?.length == 0"
    style="
      line-height: 2rem;
      border: 1px solid #ccc;
      border-radius: 8px;
      font-size: 1rem;
      text-align: center;
      margin-bottom: 15px;
      padding: 10px;
      text-align: center;
    "
  >
    No Customer Order Preferences
  </div>

  <div
    *ngIf="customerOrderPreferences?.length > 0"
    style="max-height: 132px; overflow-y: auto; margin-bottom: 15px"
  >
    <p-table
      selectionMode="none"
      [value]="customerOrderPreferences"
      [lazy]="true"
      [responsive]="true"
      [paginator]="false"
      [styleClass]="'rowStyle'"
      [resizableColumns]="true"
      [autoLayout]="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Date/Time</th>
          <th>Customer</th>
          <th>Reason</th>
          <th>User</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.updatedDate | date : 'dd/MM/yy' }}</td>
          <td>{{ item.organisationName }}</td>
          <td>{{ item.reason }}</td>
          <td>{{ item.updatedByUserName }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div style="float: right">
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      (click)="this.showAuditDialog = false"
    ></button>
  </div>
</p-dialog>

<span *ngIf="isLoading && !isLoaded">
  <span class="loading-notice"> <i class="fa fa-spin fa-2x fa-spinner"></i> &nbsp; Loading </span>
</span>
